module.exports = __webpack_public_path__ + "img/safari-table-icon.b64f452c.svg";